export default "__VITE_ASSET__ByASjoXq__"